import React from "react";
import { Container } from "../container";
import { Button } from "../button";

export const Buttons: React.FC<{
  items: (null | {
    id: string;
    title: string | null;
    url: string | null;
  })[];
}> = ({ items, ...props }) => {
  return (
    <Container {...props} className="my-6 grid grid-cols-4 gap-16 ">
      {/* <div className="flex"> */}
      <div className="col-span-1" />
      <div className="col-span-2 md:flex">
        {items.map((item) => {
          if (!item) return null;
          const { id, title, url } = item;
          return <Button {...{ id, title, url }} key={`button-${id}`} />;
        })}
      </div>
      {/* </div> */}
    </Container>
  );
};
